module.exports = __webpack_public_path__ + "static/assets/128d00315c357cbd7ce82548e04512a7.svg";